export enum ReleaseTypeEnum {
  Single = 1,
  EP = 2,
  Album = 3,
}
